import md5 from "md5";

export const getGravatarImage = (email) => {
  return "https://www.gravatar.com/avatar/" + md5(email) + "?d=404";
};
